<div id="error">
  <span class="icon fas fa-exclamation-triangle"></span>
  <span class="not-found">Page non trouvée</span>
</div>
